export default __webpack_public_path__ + "static/media/add-user-disabled.b2c5aba3.svg";